<template>
    <InvoicesViewComponent parent="invoices-view"></InvoicesViewComponent>
</template>

<script>
import InvoicesViewComponent from '@/components/InvoiceDetails.vue';
export default {
 components: {InvoicesViewComponent},
 setup() {

 }
}

</script>